/* src/app/common/components/order-type/order-type.component.scss */
:host {
  display: inline-block;
  --color: var(--ion-color-primary);
}
.type-info-container {
  display: flex;
}
.icon {
  margin-right: 4px;
  color: var(--color);
}
.label {
  color: var(--color);
  line-height: 23px;
}
/*# sourceMappingURL=order-type.component.css.map */
